import { type ValueOf } from "./utility-types/value-of.types";

import type { AddressStored, CasAddressStored } from "./Address";

export enum CustomAttributeDataKeys {
  PreferredLanguage = "preferredLanguage",
  NewsletterPreferences = "newsletterPreferences",
  TextMessagePreferences = "textMessagePreferences",
  PostMailPreferences = "postMailPreferences",
}

/**
 * @deprecated Use CustomAttributeDataKeys instead
 */
export enum DataKeys {
  PreferredLanguage = "preferredLanguage",
  NewsletterPreferences = "newsletterPreferences",
  TextMessagePreferences = "textMessagePreferences",
  PostMailPreferences = "postMailPreferences",
}

export type PreferredLanguageData = {
  language: string;
};

export type NewsletterPreferencesData = {
  email: string;
  marketingEmailsEnabled?: boolean;
  frequency: string;
  category: {
    updates: boolean;
    promotions: boolean;
    news: boolean;
  };
};

export type TextMessagePreferencesData = {
  contact: string;
  frequency: string;
  marketingSmsEnabled?: boolean;
  category: {
    alert: boolean;
    news: boolean;
  };
};

export type PostMailPreferencesData = {
  addresses: AddressStored[];
  selectedAddressId: string;
  frequency: string;
  category: {
    alert: boolean;
    news: boolean;
  };
};

export type CustomAttributeData = {
  [CustomAttributeDataKeys.PreferredLanguage]: PreferredLanguageData;
  [CustomAttributeDataKeys.NewsletterPreferences]: NewsletterPreferencesData;
  [CustomAttributeDataKeys.TextMessagePreferences]: TextMessagePreferencesData;
  [CustomAttributeDataKeys.PostMailPreferences]: PostMailPreferencesData;
};

/**
 * @deprecated Use CustomAttributeData instead
 */
export type Data = {
  [CustomAttributeDataKeys.PreferredLanguage]: PreferredLanguageData;
  [CustomAttributeDataKeys.NewsletterPreferences]: NewsletterPreferencesData;
  [CustomAttributeDataKeys.TextMessagePreferences]: TextMessagePreferencesData;
  [CustomAttributeDataKeys.PostMailPreferences]: PostMailPreferencesData;
};

/**
 * @deprecated Use ValueOf<CustomAttributeData> instead
 */
export type ValueOfData = ValueOf<CustomAttributeData>;

export type UpdateCustomAttributeResponse = {
  customer: {
    id: number;
    group_id: number;
    created_at: string;
    updated_at: string;
    created_in: string;
    dob: string;
    email: string;
    firstname: string;
    lastname: string;
    stored_id: number;
    website_id: number;
  };
  addresses: CasAddressStored[];
  stored_address_id: number;
};
